/**
 * Host Left Modal Component
 *
 * Displayed when host ends the call, giving guest option to stay or leave.
 * Shows 60-second countdown timer.
 */

import React, { FC } from 'react';
import { UserMinus } from 'lucide-react';

export interface HostLeftModalProps {
  countdown: number;
  onStay: () => void;
  onLeaveNow: () => void;
}

export const HostLeftModal: FC<HostLeftModalProps> = ({ countdown, onStay, onLeaveNow }) => {
  return (
    <div className="fixed inset-0 z-[200] bg-black/60 backdrop-blur-sm flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl p-6 max-w-sm w-full mx-4 shadow-2xl animate-in fade-in zoom-in duration-200">
        {/* Icon */}
        <div className="text-center mb-6">
          <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
          
          </div>

          {/* Title */}
          <h2 className="text-xl font-semibold text-gray-900 mb-2">Host Left the Call</h2>

          {/* Countdown */}
          <div className="relative py-4">
            <p
              className={`text-5xl font-bold transition-colors duration-300 ${
                countdown <= 10 ? 'text-red-600' : 'text-orange-600'
              }`}
            >
              {countdown}s
            </p>

            {/* Countdown indicator */}
            {countdown <= 10 && (
              <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                <div className="w-24 h-24 border-4 border-red-200 rounded-full animate-ping opacity-25" />
              </div>
            )}
          </div>

        </div>

        {/* Action buttons */}
        <div className="flex gap-3">
          <button
            onClick={onStay}
            className="flex-1 px-4 py-3 bg-gray-100 text-gray-700 rounded-xl font-medium hover:bg-gray-200 active:bg-gray-300 transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-offset-2"
          >
            Stay in Call
          </button>
          <button
            onClick={onLeaveNow}
            className="flex-1 px-4 py-3 bg-orange-600 text-white rounded-xl font-medium hover:bg-orange-700 active:bg-orange-800 transition-colors duration-150 focus:outline-none focus:ring-2 focus:ring-orange-500 focus:ring-offset-2"
          >
            End Call Now
          </button>
        </div>
      </div>
    </div>
  );
};
